export default __webpack_public_path__ + "static/media/talksig-text-logo.787b1606.png";